"use client";

import React from "react";
import Image from "next/image";
import GTMLink from "../../GTMLink";
import { GoogleTagManagerEvents } from "../../../../common";
import TypographyMontserrat from "../../../Atoms/TypographyMontserrat";
import { NewRightArrow } from "../../../../public/Theme";

const HeaderLinkWithIcon = ({
    text,
    link,
    flyoutLinks,
    onClick,
    setSectionLinks,
}) => {
    return (
        <>
            {!flyoutLinks ? (
                <GTMLink
                    event={GoogleTagManagerEvents.navigationInteractions}
                    place={"header"}
                    menuName={"header navigation menu"}
                    href={link || ""}
                    passHref
                    onClick={onClick}
                    prefetch
                >
                    <div className="flex justify-between py-5 min-w-52  ">
                        <TypographyMontserrat
                            size={"base"}
                            fontWeight={"medium"}
                            text={text}
                            customStyle={
                                "!cursor-pointer !capitalize !text-Text_Gray"
                            }
                        />
                    </div>
                </GTMLink>
            ) : (
                <div
                    className="flex justify-between py-5 w-full  "
                    onClick={() => {
                        setSectionLinks(flyoutLinks);
                    }}
                >
                    <TypographyMontserrat
                        size={"base"}
                        fontWeight={"medium"}
                        text={text}
                        customStyle={
                            "!cursor-pointer !capitalize !text-Text_Gray"
                        }
                    />
                    <Image
                        width={14}
                        height={14}
                        loading="lazy"
                        src={NewRightArrow}
                        alt={"Header Icon"}
                    />
                </div>
            )}
        </>
    );
};

export default HeaderLinkWithIcon;
